import axiosApi from './util'
import store from '../../store'

export default {
  query (query) {
    return new Promise( (resolutionFunc, rejectionFunc) => {
      return axiosApi.post('/graphql', query)
        .then(response => {
          if (response.data.errors) {
            const statusCodes = []
            const errorMessages = []
            const validateFeedback = {}
            for (const error of response.data.errors) {
              const errorObj = JSON.parse(error.message)
              statusCodes.push(errorObj.status_code)
              for (const errorMessage of errorObj.messages) {
                errorMessages.push(errorMessage)
              }
              for (const key in errorObj.validate_feedback) {
                const validateErrorMessages = []
                for (const err of errorObj.validate_feedback[key]) {
                  validateErrorMessages.push(err)
                }
                validateFeedback[key] = validateErrorMessages
              }
            }
            
            const mergedError = {
              statusCodes: statusCodes, 
              messages: errorMessages, 
              validateFeedback: validateFeedback, 
            }

            for (const statusCode of statusCodes) {
              if (statusCode === 403) {
                store.commit('page/setPermissionInsufficient', true)
                rejectionFunc(mergedError)
                return // No need to set errors
              }
            }
            if (mergedError.messages.length > 0) {
              store.commit('page/set', ["errors", mergedError])
            }
            
            rejectionFunc(mergedError)
          } else {
            resolutionFunc(response.data.data)
          }
        }, err => {
          console.error(err)
          rejectionFunc(err)
        })
    })
  },

  listPages () {
    return this.query({
      query: `
        query{
          GetPagePaths{
            name
            path
          }
        }
      `,
    }).then(data => {
      return data.GetPagePaths
    })
  },

  getPage (path) {
    return this.query({
      query: `
        query($path: String!){
          GetPage(path: $path){
            id
            global_style {
              style
            } 
            section_builders {
              id
              static_data
              style
              template
            } 
            seo_info
          }
        }
      `,
      variables: {
        path,
      },
    }).then(data => {
      return data.GetPage
    })
  },
}